// import Vue from 'vue'
import {
  Menu,
  Submenu,
  MenuItem,
} from 'element-ui'
import './theme.scss'

// FIXME:
// 清理openKeys，selectedKeys等
// icon

export default {
  name: 'ZMenu',
  props: {
    mode: {
      type: String,
      required: false,
      default: 'vertical',
    },
    menu: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data () {
    return {
      openKeys: [],
      selectedKeys: [],
      cachedOpenKeys: [],

      activeRoute: '',
    }
  },
  computed: {
    rootSubmenuKeys: vm => {
      const keys = []
      vm.menu.forEach(item => keys.push(item.path))
      return keys
    },
  },
  created () {
    this.updateMenu()
  },
  watch: {
    // collapsed (val) {
    //   if (val) {
    //     this.cachedOpenKeys = this.openKeys.concat()
    //     this.openKeys = []
    //   } else {
    //     this.openKeys = this.cachedOpenKeys
    //   }
    // },
    $route () {
      this.updateMenu()
    }
  },
  methods: {
    renderIcon (h, icon) {
      return icon === 'none' || icon === undefined
        ? null
        : <i class={[icon]}></i>
    },
    renderMenuItem: function (h, menu, pIndex, index) {
      return (
        <MenuItem
          key={menu.path ? menu.path : 'item_' + pIndex + '_' + index}
          index={menu.path}
          class={[this.theme === 'dark' ? 'z-menu__item--dark' : 'z-menu__item--light']}
        >
          {this.renderIcon(h, menu.meta.icon)}
          <span>{menu.meta.title}</span>
        </MenuItem>
      )
    },
    renderSubMenu: function (h, menu, pIndex, index) {
      const subItem = [
        <template slot="title">
          {this.renderIcon(h, menu.meta.icon)}
          <span>{menu.meta.title}</span>
        </template>
      ]
      const itemArr = []
      const pIndex_ = pIndex + '_' + index
      if (!menu.alwaysShow) {
        menu.children.forEach((item, i) => {
          itemArr.push(this.renderItem(h, item, pIndex_, i))
        })
      }

      return (
        <Submenu
          key={menu.path ? menu.path : 'submenu_' + pIndex + '_' + index}
          index={menu.path}
          popper-append-to-body={false}
          class={[this.theme === 'dark' ? 'z-menu__title--dark' : 'z-menu__title--light']}
        >
          {subItem.concat(itemArr)}
        </Submenu>
      )
    },
    renderItem: function (h, menu, pIndex, index) {
      if (!menu.hidden) {
        return menu.children && !menu.alwaysShow
          ? this.renderSubMenu(h, menu, pIndex, index)
          : this.renderMenuItem(h, menu, pIndex, index)
      }
    },
    // 最外层
    renderMenu: function (h, menuTree) {
      const menuArr = []
      // const isMT = Cookie.getJSON('AppUserInfo').marketCodes.includes('000') // 当前是否是沐甜市场
      menuTree.forEach((menu, i) => {
        // if (isMT && menu.path.includes('my-account')) { // 如果是沐甜市场，将我的账户这个路由设为隐藏
        //   menu.hidden = true
        // }
        if (!menu.hidden) {
          menuArr.push(this.renderItem(h, menu, '0', i))
        }
      })
      return menuArr
    },
    onOpenChange (openKeys) {
      const latestOpenKey = openKeys.find(key => !this.openKeys.includes(key))
      if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    },
    updateMenu () {
      const routes = this.$route.matched.concat()
      if (routes.length >= 4 && this.$route.meta.hidden) {
        routes.pop()
        this.activeRoute = routes[2].path
      } else {
        this.activeRoute = routes.pop().path
      }

      const openKeys = []
      if (this.mode === 'inline') {
        routes.forEach(item => {
          openKeys.push(item.path)
        })
      }

      this.collapsed ? (this.cachedOpenKeys = openKeys) : (this.openKeys = openKeys)
    }
  },
  render (h) {
    return (
      <Menu
        class={[this.theme === 'dark' ? 'z-menu-dark' : 'z-menu-light']}
        mode={this.$props.mode}
        openKeys={this.openKeys}
        default-active={this.activeRoute}
        onOpenChange={this.onOpenChange}
        onSelect={obj => {
          this.$emit('select', obj)
        }}
        router={true}
        collapse={this.$props.collapsed}
      >
        {this.renderMenu(h, this.menu)}
      </Menu>
    )
  }
}
